function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect, useContext } from 'react';
import { Input } from 'antd';
import omit from 'omit.js';
import classnames from 'classnames';
import { LocaleContext } from "../locale";
import formMethods from "../utils/form-methods";
import "./style/text-area";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IglooTextArea = function IglooTextArea(props) {
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var maxLength = props.maxLength,
    onChangeProps = props.onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    haveInput = _useState2[0],
    setHavaInput = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLeft = _useState4[0],
    setShowLeft = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    inputValue = _useState6[0],
    setInputValue = _useState6[1];
  useEffect(function () {
    if (!haveInput) {
      setShowLeft(false);
      return;
    }
    if (maxLength && haveInput) {
      setShowLeft(true);
    }
  }, [maxLength, haveInput, inputValue]);
  function handleOnChange(e, onChangeProps, maxLength) {
    onChangeProps && onChangeProps(e);
    if (!maxLength) return;
    var value = e.target.value;
    value === '' ? setHavaInput(false) : setHavaInput(true);
    setInputValue(value);
  }
  var canInputNum = maxLength ? maxLength - inputValue.length : 1;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames("".concat(canInputNum < 0 ? 'igloo-input-text-area-error' : ''), 'igloo-input-text-area'),
    children: [/*#__PURE__*/_jsx(Input.TextArea, _objectSpread(_objectSpread({
      className: classnames('igloo-input'),
      rows: 3
      // 截取了maxlength的控制权没有交给 antd组件，样式需要控制
    }, omit(props, [].concat(_toConsumableArray(formMethods), ['maxLength']))), {}, {
      onChange: function onChange(e) {
        return handleOnChange(e, onChangeProps, maxLength);
      }
    })), /*#__PURE__*/_jsx("div", {
      className: "igloo-input-text-area-right-bottom-cover"
    }), showLeft && /*#__PURE__*/_jsx("div", {
      className: "".concat(canInputNum < 0 ? 'igloo-input-text-area-remind-has-error' : 'igloo-input-text-area-remind'),
      children: canInputNum < 0 ? formatMessage({
        id: '{canInputNum} characters over',
        values: {
          canInputNum: -canInputNum
        }
      }) : formatMessage({
        id: '{canInputNum} characters left',
        values: {
          canInputNum: canInputNum
        }
      })
    })]
  });
};
function checkNumber(value, maxLength, required) {
  if (!value) {
    return Promise.resolve();
  }
  if (maxLength && value.length > maxLength) {
    return Promise.reject();
  }
  return Promise.resolve();
}
IglooTextArea.formItemPropsHandler = function (config) {
  var required = config.required,
    maxLength = config.maxLength;
  return {
    rules: [{
      validator: function validator(_, value) {
        return checkNumber(value, maxLength, required);
      }
    }]
  };
};
export default IglooTextArea;